(() => {
  if (window.moshitaPdpBound) return;
  window.moshitaPdpBound = true;
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-moshita-gallery-step]');
    if (step) {
      const gallery = step.closest('.feature-product-media');
      const thumbnails = [...gallery.querySelectorAll('.slide-thumbnail .tns-slider > .slider-thumbnail')];
      if (thumbnails.length > 1) {
        const current = Math.max(0, thumbnails.findIndex(item => item.classList.contains('tns-nav-active')));
        const next = (current + Number(step.dataset.moshitaGalleryStep) + thumbnails.length) % thumbnails.length;
        thumbnails[next].querySelector('img')?.click();
      }
      return;
    }
    const button = event.target.closest('.moshita-pdp-zoom');
    if (!button) return;
    const gallery = button.closest('.feature-product-media');
    const image = gallery.querySelector('.slide-section-media .tns-slide-active.slider-image img')
      || gallery.querySelector('.gallery-zoom .slider-image img') || gallery.querySelector('.slider-image img');
    image?.click();
  });
})();
